export const CATALOG = {
  USA: 21,
  INT: 16,
};

export const FAMILIES = {
  STICKS: [5025, 5037],
  TUBE: [5014, 5024],
};

export enum DESCRIPTION_TIMINGS {
  PREPARATION = 'PREPARA',
  ASSEMBLY = 'MONTAJE',
  PACKAGING = 'EMBALAJE',
}

export enum PROJECT_CREATION_LEVELS {
  COMPOSITIONS = 'compositions',
  ARTICLES = 'articles',
  PARTS = 'parts',
  ACCESSORIES = 'accessories',
}

export enum SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum PRODUCT_CATEGORIES {
  REGULAR = 1,
  SPECIFIC_PLAYER,
  MODULAR,
  LG2,
  VIRTUAL,
  TOOLKIT,
}
